import React from "react";

import AttachmentsView from "components/AttachmentsView";
import WaitForSync from "components/LoadingSpinner/WaitForSync";

import { ApiModel } from "constants/loading";

const Attachments = () => (
  <WaitForSync requiredData={[ApiModel.BUSINESSES, ApiModel.CONSIGNMENTS]}>
    <AttachmentsView />
  </WaitForSync>
);

export default Attachments;
